<div class="avatar-init">
  {{firstNameInitial+lastNameInitial}}
</div>
